"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[831],{

/***/ 68314:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "O": function() { return /* binding */ PopularTagList; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/* harmony import */ var _emotion_react__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(70917);
/* harmony import */ var react_i18next__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(26793);
/* harmony import */ var main_javascripts_styles_base_spaceStyle__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(96749);
/* harmony import */ var main_javascripts_styles_base_colorStyle__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(80910);
/* harmony import */ var main_javascripts_styles_base_typographyStyle__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(36716);
/* harmony import */ var main_javascripts_constants_PostConstants__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(87687);
/* harmony import */ var main_javascripts_constants_Constants__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(25968);
/* harmony import */ var _emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(35944);










var PopularTagList = function PopularTagList(props) {
  var tags = props.tags;

  var _useTranslation = (0,react_i18next__WEBPACK_IMPORTED_MODULE_6__/* .useTranslation */ .$)(["component"]),
      t = _useTranslation.t;

  if (tags.length === 0) {
    return null;
  }

  return (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_7__/* .jsxs */ .BX)("div", {
    css: blockStyle,
    children: [(0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_7__/* .jsx */ .tZ)("div", {
      css: titleStyle,
      children: t("post.popularTags")
    }), (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_7__/* .jsx */ .tZ)("div", {
      css: listStyle,
      children: tags.map(function (_ref) {
        var id = _ref.id,
            name = _ref.name;
        return (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_7__/* .jsxs */ .BX)("a", {
          href: "".concat(main_javascripts_constants_Constants__WEBPACK_IMPORTED_MODULE_5__/* .PATH_SCOPE */ .j1, "/").concat(main_javascripts_constants_PostConstants__WEBPACK_IMPORTED_MODULE_4__/* .POST_SLUG */ .YF, "/tags/").concat(id),
          css: tagStyle,
          children: [(0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_7__/* .jsx */ .tZ)("span", {
            css: hashStyle,
            children: "#"
          }), name]
        }, name);
      })
    })]
  });
};
var blockStyle = /*#__PURE__*/(0,_emotion_react__WEBPACK_IMPORTED_MODULE_8__.css)("padding:", main_javascripts_styles_base_spaceStyle__WEBPACK_IMPORTED_MODULE_1__/* .space.atom1_5x */ .D.atom1_5x, " ", main_javascripts_styles_base_spaceStyle__WEBPACK_IMPORTED_MODULE_1__/* .space.atom2x */ .D.atom2x, ";background-color:#fff;" + ( true ? "" : 0),  true ? "" : 0);
var titleStyle = /*#__PURE__*/(0,_emotion_react__WEBPACK_IMPORTED_MODULE_8__.css)("font-size:", main_javascripts_styles_base_typographyStyle__WEBPACK_IMPORTED_MODULE_3__/* .fontSize.subHeading */ .JB.subHeading, ";font-weight:", main_javascripts_styles_base_typographyStyle__WEBPACK_IMPORTED_MODULE_3__/* .fontWeight.medium */ .Ue.medium, ";padding:0 ", main_javascripts_styles_base_spaceStyle__WEBPACK_IMPORTED_MODULE_1__/* .space.atom2x */ .D.atom2x, " ", main_javascripts_styles_base_spaceStyle__WEBPACK_IMPORTED_MODULE_1__/* .space.atom1_5x */ .D.atom1_5x, ";margin:0 -", main_javascripts_styles_base_spaceStyle__WEBPACK_IMPORTED_MODULE_1__/* .space.atom2x */ .D.atom2x, ";border-bottom:2px solid;letter-spacing:", main_javascripts_styles_base_typographyStyle__WEBPACK_IMPORTED_MODULE_3__/* .letterSpacing.title */ .rX.title, ";" + ( true ? "" : 0),  true ? "" : 0);
var listStyle = /*#__PURE__*/(0,_emotion_react__WEBPACK_IMPORTED_MODULE_8__.css)("padding:", main_javascripts_styles_base_spaceStyle__WEBPACK_IMPORTED_MODULE_1__/* .space.atom3x */ .D.atom3x, " 0 0;" + ( true ? "" : 0),  true ? "" : 0);
var tagStyle = /*#__PURE__*/(0,_emotion_react__WEBPACK_IMPORTED_MODULE_8__.css)("color:", main_javascripts_styles_base_colorStyle__WEBPACK_IMPORTED_MODULE_2__/* .textColor.primaryDarkColor */ .zP.primaryDarkColor, ";text-decoration:none;padding:0 ", main_javascripts_styles_base_spaceStyle__WEBPACK_IMPORTED_MODULE_1__/* .space.atom3x */ .D.atom3x, " ", main_javascripts_styles_base_spaceStyle__WEBPACK_IMPORTED_MODULE_1__/* .space.atom1_5x */ .D.atom1_5x, " 0;display:inline-block;font-size:", main_javascripts_styles_base_typographyStyle__WEBPACK_IMPORTED_MODULE_3__/* .fontSize.caption */ .JB.caption, ";line-height:", main_javascripts_styles_base_typographyStyle__WEBPACK_IMPORTED_MODULE_3__/* .lineHeight.caption3 */ .Nv.caption3, ";transition:color 0.4s ease;&:hover{color:", main_javascripts_styles_base_colorStyle__WEBPACK_IMPORTED_MODULE_2__/* .textColor.secondaryDarkColor */ .zP.secondaryDarkColor, ";}" + ( true ? "" : 0),  true ? "" : 0);
var hashStyle = /*#__PURE__*/(0,_emotion_react__WEBPACK_IMPORTED_MODULE_8__.css)("opacity:0.3;font-weight:", main_javascripts_styles_base_typographyStyle__WEBPACK_IMPORTED_MODULE_3__/* .fontWeight.medium */ .Ue.medium, ";font-size:", main_javascripts_styles_base_typographyStyle__WEBPACK_IMPORTED_MODULE_3__/* .fontSize.body */ .JB.body, ";padding-right:", main_javascripts_styles_base_spaceStyle__WEBPACK_IMPORTED_MODULE_1__/* .space.atom0_5x */ .D.atom0_5x, ";" + ( true ? "" : 0),  true ? "" : 0);

/***/ }),

/***/ 25177:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "N": function() { return /* reexport */ RegionTagList; }
});

// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/aphrodite/es/index.js + 1 modules
var es = __webpack_require__(34397);
// EXTERNAL MODULE: ./main/javascripts/styles/base/spaceStyle.ts
var spaceStyle = __webpack_require__(96749);
// EXTERNAL MODULE: ./main/javascripts/styles/base/typographyStyle.ts
var typographyStyle = __webpack_require__(36716);
// EXTERNAL MODULE: ./main/javascripts/styles/base/colorStyle.ts
var colorStyle = __webpack_require__(80910);
// EXTERNAL MODULE: ./main/javascripts/styles/base/borderStyle.ts
var borderStyle = __webpack_require__(58589);
;// CONCATENATED MODULE: ./main/javascripts/components/molecules/Post/RegionTagList/RegionTagListStyle.ts





var RegionTagListStyle = es/* StyleSheet.create */.mM.create({
  regionTagList: {
    padding: "".concat(spaceStyle/* space.atom0_5x */.D.atom0_5x, " 0.375rem 0")
  },
  regionTag: {
    color: colorStyle/* textColor.secondaryDarkColor */.zP.secondaryDarkColor,
    backgroundColor: colorStyle/* borderColor.primaryLightColor */.tv.primaryLightColor,
    textDecoration: "none",
    margin: "0 ".concat(spaceStyle/* space.atom */.D.atom, " ").concat(spaceStyle/* space.atom */.D.atom, " 0"),
    padding: "".concat(spaceStyle/* space.atom0_5x */.D.atom0_5x, " ").concat(spaceStyle/* space.atom */.D.atom),
    display: "inline-block",
    borderRadius: borderStyle/* borderRadius.message */.E.message,
    fontSize: typographyStyle/* fontSize.caption */.JB.caption,
    lineHeight: typographyStyle/* lineHeight.caption3 */.Nv.caption3,
    transition: "color 0.4s ease, background 0.4s ease",
    ":hover": {
      color: colorStyle/* textColor.primaryDarkColor */.zP.primaryDarkColor,
      backgroundColor: colorStyle/* borderColor.secondaryLightColor */.tv.secondaryLightColor
    }
  },
  noHover: {
    ":hover": {
      color: colorStyle/* textColor.secondaryDarkColor */.zP.secondaryDarkColor,
      backgroundColor: colorStyle/* borderColor.primaryLightColor */.tv.primaryLightColor
    }
  }
});
// EXTERNAL MODULE: ./main/javascripts/constants/PostConstants.ts
var PostConstants = __webpack_require__(87687);
// EXTERNAL MODULE: ./main/javascripts/constants/Constants.ts
var Constants = __webpack_require__(25968);
// EXTERNAL MODULE: ./node_modules/@emotion/react/jsx-runtime/dist/emotion-react-jsx-runtime.browser.esm.js
var emotion_react_jsx_runtime_browser_esm = __webpack_require__(35944);
;// CONCATENATED MODULE: ./main/javascripts/components/molecules/Post/RegionTagList/RegionTagList.tsx






var RegionTagList = function RegionTagList(props) {
  var regions = props.regions,
      disableLink = props.disableLink;
  var tagStyle = disableLink ? [RegionTagListStyle.regionTag, RegionTagListStyle.noHover] : RegionTagListStyle.regionTag;
  return (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("div", {
    className: (0,es/* css */.iv)(RegionTagListStyle.regionTagList),
    children: regions.map(function (_ref) {
      var id = _ref.id,
          name = _ref.name;
      return disableLink ? (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("span", {
        className: (0,es/* css */.iv)(tagStyle),
        children: name
      }, name) : (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("a", {
        href: "".concat(Constants/* PATH_SCOPE */.j1, "/").concat(PostConstants/* POST_SLUG */.YF, "?region=").concat(id),
        className: (0,es/* css */.iv)(tagStyle),
        children: name
      }, name);
    })
  });
};
;// CONCATENATED MODULE: ./main/javascripts/components/molecules/Post/RegionTagList/index.ts


/***/ }),

/***/ 87687:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Bg": function() { return /* binding */ PostTrackingLinkDomains; },
/* harmony export */   "YF": function() { return /* binding */ POST_SLUG; },
/* harmony export */   "fy": function() { return /* binding */ PostSearchGAParams; }
/* harmony export */ });
/* unused harmony export LINE_ADD_FRIEND_URL */
var POST_SLUG =  false ? 0 : "posts";
var LINE_ADD_FRIEND_URL = "https://lin.ee/tlg2Tnc";
var PostSearchGAParams = {
  utm_campaign: "line_ta1",
  utm_medium: "organic",
  utm_source: "tarip"
};
var PostTrackingLinkDomains = ["liff.line.me"];

/***/ }),

/***/ 39523:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "S": function() { return /* binding */ RankingList; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/* harmony import */ var _emotion_react__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(70917);
/* harmony import */ var react_i18next__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(26793);
/* harmony import */ var main_javascripts_styles_base_spaceStyle__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(96749);
/* harmony import */ var main_javascripts_styles_base_colorStyle__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(80910);
/* harmony import */ var main_javascripts_styles_base_typographyStyle__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(36716);
/* harmony import */ var main_javascripts_constants_Constants__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(25968);
/* harmony import */ var main_javascripts_styles_base_responsiveStyle__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(88433);
/* harmony import */ var _TagList__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(93933);
/* harmony import */ var main_javascripts_constants_PostConstants__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(87687);
/* harmony import */ var _emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(35944);
function _EMOTION_STRINGIFIED_CSS_ERROR__() { return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop)."; }













var RankingList = function RankingList(props) {
  var rankings = props.rankings;

  var _useTranslation = (0,react_i18next__WEBPACK_IMPORTED_MODULE_8__/* .useTranslation */ .$)(["component"]),
      t = _useTranslation.t;

  if (rankings.length === 0) {
    return null;
  }

  return (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_9__/* .jsxs */ .BX)("div", {
    css: blockStyle,
    children: [(0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_9__/* .jsx */ .tZ)("div", {
      css: titleStyle,
      children: t("post.rankingList")
    }), (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_9__/* .jsx */ .tZ)("div", {
      css: listStyle,
      children: rankings.map(function (post) {
        return (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_9__/* .jsxs */ .BX)("a", {
          href: "".concat(main_javascripts_constants_Constants__WEBPACK_IMPORTED_MODULE_4__/* .PATH_SCOPE */ .j1, "/").concat(main_javascripts_constants_PostConstants__WEBPACK_IMPORTED_MODULE_7__/* .POST_SLUG */ .YF, "/").concat(post.id),
          css: rankingStyle,
          children: [post.featuredImage && (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_9__/* .jsx */ .tZ)("div", {
            css: imageBlockStyle,
            children: (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_9__/* .jsx */ .tZ)("img", {
              css: imageStyle,
              src: post.featuredImage.url,
              alt: post.title
            })
          }), (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_9__/* .jsxs */ .BX)("div", {
            css: contentStyle,
            children: [(0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_9__/* .jsx */ .tZ)("div", {
              css: postTitleStyle,
              children: post.title
            }), post.tags && post.tags.length > 0 && (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_9__/* .jsx */ .tZ)("div", {
              css: tagListStyle,
              children: (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_9__/* .jsx */ .tZ)(_TagList__WEBPACK_IMPORTED_MODULE_6__/* .TagList */ .P, {
                tags: post.tags,
                disableLink: true
              })
            })]
          })]
        }, post.id);
      })
    })]
  });
};
var blockStyle = /*#__PURE__*/(0,_emotion_react__WEBPACK_IMPORTED_MODULE_10__.css)("padding:", main_javascripts_styles_base_spaceStyle__WEBPACK_IMPORTED_MODULE_1__/* .space.atom1_5x */ .D.atom1_5x, " ", main_javascripts_styles_base_spaceStyle__WEBPACK_IMPORTED_MODULE_1__/* .space.atom2x */ .D.atom2x, ";background-color:#fff;" + ( true ? "" : 0),  true ? "" : 0);
var titleStyle = /*#__PURE__*/(0,_emotion_react__WEBPACK_IMPORTED_MODULE_10__.css)("font-size:", main_javascripts_styles_base_typographyStyle__WEBPACK_IMPORTED_MODULE_3__/* .fontSize.subHeading */ .JB.subHeading, ";font-weight:", main_javascripts_styles_base_typographyStyle__WEBPACK_IMPORTED_MODULE_3__/* .fontWeight.medium */ .Ue.medium, ";padding:0 ", main_javascripts_styles_base_spaceStyle__WEBPACK_IMPORTED_MODULE_1__/* .space.atom2x */ .D.atom2x, " ", main_javascripts_styles_base_spaceStyle__WEBPACK_IMPORTED_MODULE_1__/* .space.atom1_5x */ .D.atom1_5x, ";margin:0 -", main_javascripts_styles_base_spaceStyle__WEBPACK_IMPORTED_MODULE_1__/* .space.atom2x */ .D.atom2x, ";border-bottom:2px solid;letter-spacing:", main_javascripts_styles_base_typographyStyle__WEBPACK_IMPORTED_MODULE_3__/* .letterSpacing.title */ .rX.title, ";" + ( true ? "" : 0),  true ? "" : 0);
var listStyle = /*#__PURE__*/(0,_emotion_react__WEBPACK_IMPORTED_MODULE_10__.css)("margin:", main_javascripts_styles_base_spaceStyle__WEBPACK_IMPORTED_MODULE_1__/* .space.atom */ .D.atom, " 0;padding:", main_javascripts_styles_base_spaceStyle__WEBPACK_IMPORTED_MODULE_1__/* .space.atom2x */ .D.atom2x, " 0 0;" + ( true ? "" : 0),  true ? "" : 0);
var rankingStyle = /*#__PURE__*/(0,_emotion_react__WEBPACK_IMPORTED_MODULE_10__.css)("display:flex;justify-content:space-between;align-items:flex-start;color:", main_javascripts_styles_base_colorStyle__WEBPACK_IMPORTED_MODULE_2__/* .textColor.primaryDarkColor */ .zP.primaryDarkColor, ";text-decoration:none;margin:0 0 ", main_javascripts_styles_base_spaceStyle__WEBPACK_IMPORTED_MODULE_1__/* .space.atom2x */ .D.atom2x, " 0;padding:0 0 ", main_javascripts_styles_base_spaceStyle__WEBPACK_IMPORTED_MODULE_1__/* .space.atom2x */ .D.atom2x, " 0;border-bottom:1px solid ", main_javascripts_styles_base_colorStyle__WEBPACK_IMPORTED_MODULE_2__/* .borderColor.primaryLightColor */ .tv.primaryLightColor, ";transition:color 0.4s ease;&:last-of-type{margin-bottom:0;padding-bottom:0;border:0;}&:hover{color:", main_javascripts_styles_base_colorStyle__WEBPACK_IMPORTED_MODULE_2__/* .textColor.secondaryDarkColor */ .zP.secondaryDarkColor, ";}" + ( true ? "" : 0),  true ? "" : 0);
var imageBlockStyle =  true ? {
  name: "paet51",
  styles: "width:22%;position:relative;&:after{content:\"\";display:block;padding-top:100%;}"
} : 0;
var imageStyle =  true ? {
  name: "wii35q",
  styles: "position:absolute;top:0;left:0;object-fit:cover;width:100%;height:100%"
} : 0;
var contentStyle = /*#__PURE__*/(0,_emotion_react__WEBPACK_IMPORTED_MODULE_10__.css)("width:74%;", (0,main_javascripts_styles_base_responsiveStyle__WEBPACK_IMPORTED_MODULE_5__/* .moreThanBreakpoint */ .h6)("desktop"), "{width:73%;}" + ( true ? "" : 0),  true ? "" : 0);
var postTitleStyle = /*#__PURE__*/(0,_emotion_react__WEBPACK_IMPORTED_MODULE_10__.css)("font-size:", main_javascripts_styles_base_typographyStyle__WEBPACK_IMPORTED_MODULE_3__/* .fontSize.mediumHeading */ .JB.mediumHeading, ";font-weight:", main_javascripts_styles_base_typographyStyle__WEBPACK_IMPORTED_MODULE_3__/* .fontWeight.medium */ .Ue.medium, ";line-height:", main_javascripts_styles_base_typographyStyle__WEBPACK_IMPORTED_MODULE_3__/* .lineHeight.mediumHeadline2 */ .Nv.mediumHeadline2, ";", (0,main_javascripts_styles_base_responsiveStyle__WEBPACK_IMPORTED_MODULE_5__/* .moreThanBreakpoint */ .h6)("desktop"), "{font-size:", main_javascripts_styles_base_typographyStyle__WEBPACK_IMPORTED_MODULE_3__/* .fontSize.body */ .JB.body, ";font-weight:", main_javascripts_styles_base_typographyStyle__WEBPACK_IMPORTED_MODULE_3__/* .fontWeight.regular */ .Ue.regular, ";line-height:", main_javascripts_styles_base_typographyStyle__WEBPACK_IMPORTED_MODULE_3__/* .lineHeight.body2 */ .Nv.body2, ";}" + ( true ? "" : 0),  true ? "" : 0);
var tagListStyle = /*#__PURE__*/(0,_emotion_react__WEBPACK_IMPORTED_MODULE_10__.css)("padding:", main_javascripts_styles_base_spaceStyle__WEBPACK_IMPORTED_MODULE_1__/* .space.atom0_5x */ .D.atom0_5x, " 0 0;" + ( true ? "" : 0),  true ? "" : 0);

/***/ }),

/***/ 93933:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "P": function() { return /* binding */ TagList; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/* harmony import */ var _emotion_react__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(70917);
/* harmony import */ var main_javascripts_styles_base_spaceStyle__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(96749);
/* harmony import */ var main_javascripts_styles_base_colorStyle__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(80910);
/* harmony import */ var main_javascripts_styles_base_typographyStyle__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(36716);
/* harmony import */ var main_javascripts_constants_PostConstants__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(87687);
/* harmony import */ var main_javascripts_constants_Constants__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(25968);
/* harmony import */ var _emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(35944);
function _EMOTION_STRINGIFIED_CSS_ERROR__() { return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop)."; }










var TagList = function TagList(props) {
  var tags = props.tags,
      disableLink = props.disableLink;
  return (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__/* .jsx */ .tZ)("div", {
    css: listStyle,
    children: tags.map(function (tag) {
      return disableLink ? (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__/* .jsxs */ .BX)("span", {
        css: tagStyle,
        children: [(0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__/* .jsx */ .tZ)("span", {
          css: hashStyle,
          children: "#"
        }), tag.name]
      }, tag.id) : (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__/* .jsxs */ .BX)("a", {
        css: tagStyle,
        href: "".concat(main_javascripts_constants_Constants__WEBPACK_IMPORTED_MODULE_5__/* .PATH_SCOPE */ .j1, "/").concat(main_javascripts_constants_PostConstants__WEBPACK_IMPORTED_MODULE_4__/* .POST_SLUG */ .YF, "/tags/").concat(tag.id),
        children: [(0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__/* .jsx */ .tZ)("span", {
          css: hashStyle,
          children: "#"
        }), tag.name]
      }, tag.id);
    })
  });
};
var listStyle =  true ? {
  name: "1hcx8jb",
  styles: "padding:0"
} : 0;
var tagStyle = /*#__PURE__*/(0,_emotion_react__WEBPACK_IMPORTED_MODULE_7__.css)("color:", main_javascripts_styles_base_colorStyle__WEBPACK_IMPORTED_MODULE_2__/* .textColor.secondaryDarkColor */ .zP.secondaryDarkColor, ";text-decoration:none;padding:0 ", main_javascripts_styles_base_spaceStyle__WEBPACK_IMPORTED_MODULE_1__/* .space.atom2_5x */ .D.atom2_5x, " ", main_javascripts_styles_base_spaceStyle__WEBPACK_IMPORTED_MODULE_1__/* .space.atom */ .D.atom, " 0;display:inline-block;font-size:", main_javascripts_styles_base_typographyStyle__WEBPACK_IMPORTED_MODULE_3__/* .fontSize.caption */ .JB.caption, ";line-height:", main_javascripts_styles_base_typographyStyle__WEBPACK_IMPORTED_MODULE_3__/* .lineHeight.caption3 */ .Nv.caption3, ";transition:color 0.4s ease;" + ( true ? "" : 0),  true ? "" : 0);
var hashStyle = /*#__PURE__*/(0,_emotion_react__WEBPACK_IMPORTED_MODULE_7__.css)("opacity:0.4;font-weight:", main_javascripts_styles_base_typographyStyle__WEBPACK_IMPORTED_MODULE_3__/* .fontWeight.medium */ .Ue.medium, ";font-size:", main_javascripts_styles_base_typographyStyle__WEBPACK_IMPORTED_MODULE_3__/* .fontSize.body */ .JB.body, ";padding-right:", main_javascripts_styles_base_spaceStyle__WEBPACK_IMPORTED_MODULE_1__/* .space.atom0_5x */ .D.atom0_5x, ";" + ( true ? "" : 0),  true ? "" : 0);

/***/ })

}]);